<template>
  <div class="team-card" @click.stop="$emit('join')">
    <div v-if="image" class="team-card__logo" :style="{ 'background-image': `url(${image})` }"></div>
    <div class="team-card__info">
      <div class="team-card__name" v-html="name"></div>
      <div class="team-card__location" v-html="location"></div>
      <div class="team-card__members">
        <Icon name="user-groups" size="s" /><span v-html="members"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';

export default {
  name: 'TeamCard',
  designVersion: '1.0.0',
  components: {
    Icon,
  },
  props: {
    /**
     * Ссылка на изображение
     */
    image: {
      type: String,
    },
    /**
     * Название команды
     */
    name: {
      type: String,
    },
    /**
     * Местоположение команды (город и т.п.)
     */
    location: {
      type: String,
    },
    /**
     * Число участников в команде
     */
    members: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./TeamCard";
</style>
